module.exports = __webpack_public_path__ + "img/hide.33b26d6d.png";